import { render, staticRenderFns } from "./demo-order-confirmation-flow.vue?vue&type=template&id=2006db5f&scoped=true&"
import script from "./demo-order-confirmation-flow.vue?vue&type=script&lang=js&"
export * from "./demo-order-confirmation-flow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006db5f",
  null
  
)

export default component.exports